module.exports = __webpack_public_path__ + "img/share1.03ba2d8e.03ba2d8e.svg";